import { useCallback } from 'react';

import { logError } from '@/shared/lib/logging';

export function useScrollToTop(): () => void {
    return useCallback(() => {
        const perform = () => {
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
                logError('Scroll to top failed');
            }

            const scrollingElement =
                document.scrollingElement ||
                document.documentElement ||
                document.body;

            try {
                scrollingElement.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
                try {
                    // fallback without smooth
                    // eslint-disable-next-line no-param-reassign
                    (scrollingElement as HTMLElement).scrollTop = 0;
                } catch {
                    logError('Scroll to top failed');
                }
            }

            const selectors = [
                '#root',
                '.ant-layout-content',
                '.algotech-layout-content',
                '.algotech-page',
            ];

            selectors.forEach((selector) => {
                const node = document.querySelector(
                    selector,
                ) as HTMLElement | null;

                if (!node) return;

                try {
                    (node as unknown as { scrollTo: Function }).scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                } catch {
                    // eslint-disable-next-line no-param-reassign
                    node.scrollTop = 0;
                }
            });
        };

        // Defer to after step render
        setTimeout(perform, 50);
        requestAnimationFrame(perform);
    }, []);
}
